import Shepherd from 'shepherd.js';
/**
 * Create a tour object using shepherd.js
 * @param dotNetObjectReference a Blazor DotNetObjectReference
 * @param callbackOnCancelOrComplete a callback function when the tour is cancelled or completed
 * @returns a {@link Shepherd.Tour} object
 */
export const createTour = (dotNetObjectReference: DotNet.DotNetObject, callbackOnCancelOrComplete: string) => {
    const tour = new Shepherd.Tour({
        useModalOverlay: true,
        defaultStepOptions: {
            classes: 'shadow-md bg-purple-dark',
            canClickTarget: false,
            scrollTo: false,
            cancelIcon: { enabled: true },
            when: {
                "before-show": () => {
                    let currentStep = tour.getCurrentStep();
                    if (!currentStep.options.buttons) {
                        let aryBtns = new Array();
                        let idxStep = tour.steps.indexOf(currentStep);

                        if (idxStep > 0) {
                            aryBtns.push({
                                text: "Back",
                                action: tour.back
                            });
                        }
                        if (idxStep < tour.steps.length - 1) {
                            aryBtns.push({
                                text: "Next",
                                action: tour.next
                            });
                        }
                        if (idxStep == tour.steps.length - 1) {
                            aryBtns.push({
                                text: "Complete",
                                action: tour.complete
                            });
                        }
                        currentStep.options.buttons = aryBtns;
                    }
                },
                show: () => {
                    showProgressBar(tour.getCurrentStep());
                },
                cancel: () => {
                    //_.each(Shepherd.activeTour.steps, function (step) {
                    //    step.destroy();
                    //});
                    if (dotNetObjectReference && callbackOnCancelOrComplete) {
                        dotNetObjectReference.invokeMethodAsync(callbackOnCancelOrComplete);
                    }
                },
                complete: () => {
                    //_.each(Shepherd.activeTour.steps, function (step) {
                    //    step.destroy();
                    //});
                    if (dotNetObjectReference && callbackOnCancelOrComplete) {
                        dotNetObjectReference.invokeMethodAsync(callbackOnCancelOrComplete);
                    }
                }
            }
        }
    });
    return tour;
}
export const scanSteps = (tour: Shepherd.Tour) => {
    let items = new Array();
    let nodesSnapshot = document.evaluate('//*/attribute::*[starts-with(name(), "data-walkthrough-")]', document, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
    for (let i = 0; i < nodesSnapshot.snapshotLength; i++) {
        let attr = nodesSnapshot.snapshotItem(i);
        if (!items.includes((attr as Attr).ownerElement))
            items.push((attr as Attr).ownerElement);
    };

    items.forEach((item) => {
        let id = item.dataset.walkthroughId;
        let title = item.dataset.walkthroughTitle;
        let text = item.dataset.walkthroughText;
        let scrollTo = item.dataset.walkthroughScrollto;
        let exists = (id && tour.getById(id));
        if (
            [id, title, text, scrollTo].some(function (el) { return el; }) &&
            !exists) {
            upsertStep(tour,
                id,
                title,
                text,
                item,
                scrollTo
            );
        }
    });
}
export const upsertStep = (tour: Shepherd.Tour, id: string, title: string, text: string, attachToElement: Element | string, scrollTo: boolean | ScrollIntoViewOptions,
    attachOn?: any, extraClasses?:string) => {
    scrollTo = scrollTo ?? false;
    let idx = undefined;
    if (id) {
        let stepToAdd = tour.getById(id);
        if (stepToAdd) {
            idx = tour.steps.indexOf(stepToAdd);
            tour.removeStep(id);
        }
    }
    attachToElement = (attachToElement instanceof Element) ? attachToElement : document.querySelector(attachToElement);
    //if (attachToElement)
    
    return tour.addStep({
        id: id,
        title: title,
        text: text,
        attachTo: {
            element: attachToElement as HTMLElement,
            on: attachOn ?? 'auto'
        },
        scrollTo: scrollTo,
        classes: extraClasses
    }, idx);
    

}
export const addProfileStep = (tour: Shepherd.Tour) => {
    let el = document.getElementById("liProfile");
    if (el && tour) {
        upsertStep(tour, "stepProfile", "Menu", "The user control element contains a menu that will allow a user to access other JL applications, submit feedback, set their application preferences, view version history, about and log out.", el, null, "bottom");
    }
}
export const showProgressBar = (currentStep:Shepherd.Step) => {
    let tour = currentStep.getTour();
    const currentStepElement = currentStep.getElement();
    const footer = currentStepElement.querySelector('.shepherd-footer');
    footer.classList.remove("justify-content-between");
    footer.classList.remove("align-items-center");
    footer.classList.add("justify-content-between");
    footer.classList.add("align-items-center");

    let currentStepIndex = tour.steps.indexOf(currentStep) + 1;
    let totalSteps = tour.steps.length;
    let pct = `${Math.round((currentStepIndex / totalSteps) * 100)}%`;

    const progressDiv = document.createElement("div");
    progressDiv.classList.add("w-100", "me-2", "d-flex", "flex-column", "justify-content-between", "align-items-stretch");

    const progress = document.createElement("div");
    progress.className = "progress";

    const progressBar = document.createElement("div");
    progressBar.className = "progress-bar";
    progressBar.setAttribute("role", "progressbar");
    progressBar.style.width = pct;
    progress.appendChild(progressBar);

    progressDiv.appendChild(progress);

    const progressLabel = document.createElement("div");
    progressLabel.classList.add("align-self-center");
    progressLabel.innerText = `${currentStepIndex} / ${totalSteps}`;
    progressDiv.appendChild(progressLabel);
    footer.insertBefore(progressDiv, currentStepElement.querySelector('.shepherd-button:last-child'));
}
export const startTour = (tour:Shepherd.Tour) => {
    tour.start();
}
export const destroyTour = (tour:Shepherd.Tour) => {
    if (tour) {
        tour = null;
    }
}